import styled from "styled-components";
import { Column } from "uikit";

const Root = styled(Column)`
	padding-top: 20px;
	gap: 12px;
`;

export default Root;
